import { LuPlus } from "react-icons/lu";
import Button from "../../../../../components/buttons/button";
import SalariesSearch from "./salariesSearch";
import RiyalIcon from "../../../../../icons/riyalIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../../../components/dropDownMenu/dropdown-menu";
import { TbDotsVertical } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import EditIcon from "../../../../../icons/editIcon";
import Table from "../../../../../components/table/table";
import { useState } from "react";
import Popup from "../../../../../components/popups/popup";
import SalariesEdit from "./salariesEdit";
import AddSalary from "./addSalary";
import SalaryDetails from "./salaryDetails";

const SalariesTab = ({ t }) => {
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const salaries = [
    {
      id: 1,
      employee: "أحمد هشام المدير",
      jobTitle: "مطور برمجيات",
      basicSalary: "6,500",
      allowances: "+3,500",
      deductions: "0-",
      total: "10,500",
      status: "تم الدفع",
    },
    {
      id: 2,
      employee: "سارة أحمد",
      jobTitle: "محاسب",
      basicSalary: "7,500",
      allowances: "+1,500",
      deductions: "500-",
      total: "8,500",
      status: "تعذر الدفع",
    },
    {
      id: 3,
      employee: "هشام المدير علي",
      jobTitle: "مصممة واجهات",
      basicSalary: "4,500",
      allowances: "+1,500",
      deductions: "1000-",
      total: "5,000",
      status: "تعذر الدفع",
    },
    {
      id: 1,
      employee: "أحمد هشام المدير",
      jobTitle: "مطور برمجيات",
      basicSalary: "6,500",
      allowances: "+3,500",
      deductions: "0-",
      total: "10,500",
      status: "تم الدفع",
    },
    {
      id: 3,
      employee: "هشام المدير علي",
      jobTitle: "مصممة واجهات",
      basicSalary: "4,500",
      allowances: "+1,500",
      deductions: "1000-",
      total: "5,000",
      status: "تعذر الدفع",
    },
  ];

  const tableHead = [
    {
      header: "id",
      accessorKey: "id",
    },
    {
      header: t("employee"),
      accessorKey: "employee",
    },
    {
      header: t("jobTitle"),
      accessorKey: "job",
    },
    {
      header: t("basicSalary"),
      accessorKey: "basicSalary",
    },
    {
      header: t("allowances"),
      accessorKey: "allowances",
    },
    {
      header: t("deductions"),
      accessorKey: "deductions",
    },
    {
      header: t("total"),
      accessorKey: "total",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },
    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = salaries.map((m, i) => {
    const statusColor = m.status === "تم الدفع" ? "#E6F4EF" : "#F4ECE6";
    const statusTextColor = m.status === "تم الدفع" ? "#11A849" : "#C42E27";
    const status = (
      <span
        style={{ backgroundColor: statusColor, color: statusTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {t(m.status)}
      </span>
    );
    const allowances = (
      <span className="text-[#11A849] flex items-center justify-center">
        {m.allowances} <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );
    const basicSalary = (
      <span className="flex items-center justify-center">
        {m.basicSalary}
        <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );
    const total = (
      <span className="flex items-center justify-center">
        {m.total} <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );
    const deductions = (
      <span className="text-[#C42E27] flex items-center justify-center">
        {m.deductions} <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );
    const actions = (
      <div className="relative mx-auto w-fit">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <TbDotsVertical />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <button
                onClick={() => setOpenView(true)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("showDetails")}
                <IoEyeOutline size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => setOpenEdit(true)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editInfo")}
                <EditIcon />
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
    return {
      id: m.id,
      employee: m.employee,
      allowances,
      basicSalary,
      deductions,
      job: m.jobTitle,
      total,
      status,
      actions,
    };
  });
  return (
    <div className="grid">
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <h2 className="text-lg font-bold capitalize">{t("salariesList")}</h2>
        <Button
          onClick={() => setOpenAdd(true)}
          type={"button"}
          className={"flex items-center rounded-lg gap-2 bg-[#1E4071]"}
        >
          <LuPlus size={20} className="text-white" />

          {t("addBonus/deduction")}
        </Button>
      </div>
      <SalariesSearch t={t} />
      <Table TableData={tableData} TableHead={tableHead} />
      <Popup open={openEdit} setOpen={setOpenEdit} header={t("manageSalary")}>
        <SalariesEdit t={t} setOpen={setOpenEdit} />
      </Popup>
      <Popup open={openAdd} setOpen={setOpenAdd} header={t("addBonus/deduction")}>
        <AddSalary t={t} setOpen={setOpenAdd} />
      </Popup>
      <Popup open={openView} setOpen={setOpenView} header={t("salaryDetails")}>
        <SalaryDetails t={t} />
      </Popup>
    </div>
  );
};

export default SalariesTab;
